import { Group, Text } from "@mantine/core"
import { Loader, DesignStudioParametersToolkit, InfoBox } from "@tfg/ui"
import { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"

import { SETTINGS_SCOPE } from "@tfg/types/constants/communication-studio.constant"
import { GetProductSheetGroupForProductPageResponseDto } from "@tfg/types/endpoints/communication-studio/get-product-sheet-group-for-product-page.response.dto"

import { useGetProductSheetGroupForProductPage } from "~/gen/api/hooks"
import { i18n } from "~/i18n"
import { SearchEngine } from "~/pages/Public/SearchEngine"
import { usePublicDisplaySettingsQuery } from "~/pages/Public/hooks"

export const PublicSearchEnginePage = () => {
  const params = useParams()
  const [searchParams, setSearchParams] = useSearchParams()

  const displaySlug = params.displaySlug as string

  const language = searchParams.get("lang") ?? "fr"
  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])
  const {
    data: displaySetting,
    isPending: isLoading,
    isError,
  } = usePublicDisplaySettingsQuery(displaySlug)

  const { data: productSheetGroupData, isPending: isLoadingProductSheetGroup } =
    useGetProductSheetGroupForProductPage(displaySetting?.id ?? "", {
      query: {
        enabled: !!displaySetting?.id,
      },
    })
  if (isError) {
    return (
      <Group justify="center" pt="xl">
        <Text style={{ color: "red" }}>Error</Text>
      </Group>
    )
  }
  if (isLoading || isLoadingProductSheetGroup) {
    return <Loader fullPage />
  }

  const productSheetGroup = productSheetGroupData?.data as
    | GetProductSheetGroupForProductPageResponseDto
    | undefined
  if (!productSheetGroup?.stylingParameters) {
    return <InfoBox message="No product sheet group found" />
  }

  DesignStudioParametersToolkit.injectAllClassesToDocumentHead(
    productSheetGroup.stylingParameters
  )
  DesignStudioParametersToolkit.injectCssVariablesToDocumentHead(
    productSheetGroup.stylingParameters
  )
  const stylingParameters = productSheetGroup.stylingParameters

  const contentFilteringConfiguration =
    productSheetGroup.configurations[SETTINGS_SCOPE.CONTENT_FILTERING]

  return (
    <SearchEngine
      logoUrl={contentFilteringConfiguration.logoFile?.url ?? null}
      stylingParameters={stylingParameters}
      language={language}
      setSearchParams={setSearchParams}
      slug={displaySlug}
      searchParams={searchParams}
    />
  )
}
